import { render, staticRenderFns } from "./woodenPackageType.vue?vue&type=template&id=627dbf96&"
import script from "./woodenPackageType.vue?vue&type=script&lang=js&"
export * from "./woodenPackageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627dbf96')) {
      api.createRecord('627dbf96', component.options)
    } else {
      api.reload('627dbf96', component.options)
    }
    module.hot.accept("./woodenPackageType.vue?vue&type=template&id=627dbf96&", function () {
      api.rerender('627dbf96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/woodenPackageType.vue"
export default component.exports